// extracted by mini-css-extract-plugin
export var messageSideLeft = "_qi-1";
export var stateContainer = "_qi-0";